import React, { Component } from 'react'
import { connect } from 'react-redux'
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';
import Md5 from 'md5'

import AdminHome from 'components/Admin/AdminHome';
import Bundles from 'components/Admin/Bundles';
import Soundboxs from 'components/Admin/Soundboxs';
import SeeSoundbox from 'components/Admin/SeeSoundbox';
import SoundboxRendered from 'components/Admin/SoundboxRendered';

import { loadInitialData } from 'redux/actions';

import Paths from 'paths'

import loading from 'img/loading.png';
import 'css/styles.css';
import 'css/login.css';

class Admin extends Component{

    componentDidMount() {
        this.props.loadInitialData();
    };

    render() {
        if(this.props.location.pathname !== Paths.PATH_DEMO && sessionStorage.getItem("logged-hash") !== Md5(process.env.REACT_APP_LOGIN_PW)) {
            return <Redirect to={{
                pathname: Paths.PATH_ADMIN_LOGIN,
                state: this.props.location
            }}/>
        } else if(this.props.loading) {
            return (
                <section id="main" className={'loading'}>
                    <img id={'loading-logo'} src={loading} title={'loading'} alt={'loading'}/>
                </section>
            );
        } else {
            return(
                <section id="main">
                    <BrowserRouter>
                        <Switch>
                            <Route exact path={Paths.PATH_ADMIN_SHOW_BUNDLES} component={Bundles} />
                            <Route exact path={Paths.PATH_ADMIN_EDIT_BUNDLES} component={Bundles} />
                            <Route exact path={Paths.PATH_ADMIN_ADD_BUNDLES} component={Bundles} />

                            <Route exact path={Paths.PATH_ADMIN_SHOW_SOUNDBOXS} component={Soundboxs} />
                            <Route exact path={Paths.PATH_ADMIN_SHOW_SOUNDBOX} component={SeeSoundbox} />
                            <Route exact path={Paths.PATH_ADMIN_SHOW_SOUNDBOX_RENDERED} component={SoundboxRendered} />
                            <Route exact path={Paths.PATH_ADMIN_ADD_MOVIE} component={SeeSoundbox} />
                            <Route exact path={Paths.PATH_ADMIN_EDIT_MOVIE} component={SeeSoundbox} />
                            <Route exact path={Paths.PATH_ADMIN_ADD_CHARACTER} component={SeeSoundbox} />
                            <Route exact path={Paths.PATH_ADMIN_EDIT_CHARACTER} component={SeeSoundbox} />
                            <Route exact path={Paths.PATH_ADMIN_ADD_SOUND} component={SeeSoundbox} />
                            <Route exact path={Paths.PATH_ADMIN_EDIT_SOUND} component={SeeSoundbox} />

                            <Route exact path={Paths.PATH_ADMIN_HOME} component={AdminHome} />
                        </Switch>
                    </BrowserRouter>
                </section>
            )
        }
    }

}

const mapStateToProps = (state) => {
    return (state);
};

const mapDispatchToProps = { loadInitialData };

export default connect(mapStateToProps, mapDispatchToProps)(Admin);
